<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
// import Select from "@/components/c-select";
import ServiceRow from "../../../../components/manage-sevice-row";

import { propertyUtility } from "../../../../services/managements/propertyservice/propertyutility.service";
import { propertyService } from "../../../../services/managements/propertyservice/property.service";
// import { projectService } from "../../../../services/managements/propertyservice/property.service";
import { service } from "../../../../services/managements/services/service";
import { propertyServiceService } from "../../../../services/managements/propertyservice/propertyservice.service";
import { utilityService } from "../../../../services/managements/utilities/utility.service";
import { invoiceService } from "../../../../services/managements/invoices/invoice.service";

// import { servicehelpers } from "../../../../services/servicehelpers";

import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Utility Rcord Form",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loading,
    Button,
    Input,
    Area,
    // Select,
    ServiceRow,
  },
  data() {
    return {
      dropdownSelection: {},

      fetchingStats: false,
      tryingToSubmit: false,
      title: "Utility Record",
      breadCrumb: {},
      projectData: {},
      propertyData: {},
      serviceData: {},
      modifiedServiceData: {},
      propertyServiceData: {},
      discountTypeData: {},
      utilityData: {},
      invoiceData: {},

      isShowUtility: true,
      isVoid: false,

      dataProjectId: 0,
      dataPropertyId: 0,
      dataWatter: 0,
      dataWatterPrice: 0,
      dataWatterAmount: 0,
      dataElectrict: 0,
      dataElectrictPrice: 0,
      dataElectrictAmount: 0,
      dataLastWatter: 0,
      dataLastElectrict: 0,

      dataInvoiceDate: this.$moment().clone().format("YYYY-MM-DD"),
      dataInvoiceExpiredDate: this.$moment()
        .add(10, "days")
        .format("YYYY-MM-DD"),
      dataUtilityStartDate: this.$moment().clone().format("YYYY-MM-DD"),
      dataUtilityEndDate: "",

      dataVoidDate: this.$moment().clone().format("YYYY-MM-DD"),
      dataVoidReason: "",
      dataVoidRef: "",
      dataVoidBy: JSON.parse(localStorage.getItem('user')).id,
      dataVoidByName: JSON.parse(localStorage.getItem('user')).name,

      validateInvoice: true,
    };
  },
  mounted() {
    let hasId = "id" in this.$route.params;
    if (hasId) {
      this.loadingInvoice(this.$route.params.id)
      setTimeout(() => {
        this.loadingData(this.dataPropertyId);
      }, 2000);
    } else {
      this.loadingData(0);
    }

    // this.loadingDiscountTypeData();
  },

  methods: {
    loadingData: function (id) {
      this.fetchingStats = true;
      propertyService.getOne(id).then((response) => {
        if (id != 0) {
          // console.log(response)
          this.propertyData = response.data;
          this.dataProjectId = response.data.project_id;
          this.dataLastWatter = response.data.last_watter_record;
          this.dataLastElectrict = response.data.last_electrict_record;
        }
        // this.validateExistInvoice();

        this.loadServiceData(id);
        this.loadUitlityByProjectId(this.dataProjectId);
        this.projectData = { data: response.setting.projects };
        this.dataUtilityStartDate = this.getUtilityDate();
        this.dataUtilityEndDate = this.getUtilityDate(true);
      });
    },

    loadingInvoice: function(id){
      this.fetchingStats = true;
      invoiceService.getOne(id)
        .then(response => {
          if(id != 0){
            console.log(response)
            this.invoiceData = response.data;
            this.dataVoidRef = this.invoiceData.invoice.code;
            this.dataPropertyId = this.invoiceData.invoice.property_id
          }
        }); 
    },

    validateExistInvoice: function () {
      let data = {
        property_id: this.dataPropertyId,
        invoice_date: this.dataInvoiceDate,
      };

      propertyUtility.validateExistInvoice(data).then((response) => {
        if (response.status == "error") {
          this.popAlertWarning(response.message);
          return false;
        } else {
          return true;
        }
      });
    },

    loadServiceData: function (id, param = "?page=0") {
      service.getList(param).then((response) => {
        let currentData = response.data;
        this.serviceData = currentData;
        this.loadServiceByPropertyId(id);
      });
    },

    loadUitlityByProjectId: function (id, param = "") {
      param = `?page=0&clause={"clause":[{"conjuction":"and","mg_utilities.project_id":{"value":${id}}}]}`;
      utilityService.getList(param).then((response) => {
        this.utilityData = response.data;
        this.dataWatterPrice = this.utilityData[0].price;
        this.dataElectrictPrice = this.utilityData[1].price;
      });
    },

    loadServiceByPropertyId: function (id, param = "?page=0") {
      param = `?page=0&clause={"clause":[{"conjuction":"and","mg_property_services.property_id":{"value":${id}}}]}`;
      propertyServiceService.getList(param).then((response) => {
        if (id != 0) {
          this.propertyServiceData = response.data;
          let selected_services = this.propertyServiceData.map(
            (item) => item.service_id
          );
          if (this.serviceData) {
            this.serviceData.map((item, i) => {
              let check = selected_services.includes(item.id);
              this.serviceData[i].check = check;
              this.serviceData[i].quantity = check
                ? this.propertyServiceData[i].quantity
                : 1;
              this.serviceData[i].service_for =
                (this.propertyServiceData[i]) ? this.propertyServiceData[i].service_for : 1;
              this.modifiedServiceData = this.serviceData;
            });
            this.getBillDate();
          }
        }
      });

      // this.loadServiceData();
      console.log(this.modifiedServiceData);
    },


    getBillDate: function () {
      this.propertyServiceData.map((item, i) => {
        this.serviceData.map((s, k) => {
          if (item.service_id == s.id) {
            this.serviceData[k].monthBilling =
              this.propertyServiceData[i].billing_cycle_date;
          }
        });
      });
    },

    getUtilityDate(end_date = false) {
      let day = this.propertyData.monthly_billing_date;
      let month = !end_date
        ? this.$moment().format("MM")
        : this.$moment().add(1, "M").format("MM");
      let year = this.$moment().format("YYYY");
      console.log(`${year}-${month}-${day}`);
      return `${year}-${month}-${day}`;
    },

    popAlertWarning: function (message) {
      this.$swal
        .fire({
          title: i18n.t("general.invalid.title"),
          text: message,
          icon: "warning",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t("general.ok"),
        })
        .then((result) => {
          if (result.value) {
            this.dataWatter = 0;
            return false;
          }
        });
    },

    confirmInvalid: function () {
      this.$swal
        .fire({
          title: i18n.t("general.invalid.title"),
          text: "គីឡូទឹកថ្មី មិនអាចតូចជាគីឡូចាស់",
          icon: "warning",
          confirmButtonColor: "#34c38f",
          confirmButtonText: i18n.t("general.ok"),
        })
        .then((result) => {
          if (result.value) {
            this.dataWatter = 0;
            return false;
          }
        });
    },

    projectChanged: function (event) {
      this.project = event;
      if (this.dataLastProject != 0) {
        this.loadingPropertyData(this.project);
      }
      this.dataLastProject = event;
    },

    formatCurrency(value) {
      if (value == 0) {
        return 0;
      }
      let sign = "$";
      let decimal = ".00";
      return this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);

      // return value;
    },

    propertyChanged: function (property) {
      this.loadingPropertyById(property.id);
    },

    watterChanged: function () {
      if (this.dataWatter > this.dataLastWatter) {
        this.dataWatterAmount =
          (this.dataWatter - this.dataLastWatter) * this.dataWatterPrice;
      }
    },

    electrictChanged: function () {
      if (this.dataElectrict > this.dataLastElectrict) {
        this.dataElectrictAmount =
          (this.dataElectrict - this.dataLastElectrict) *
          this.dataElectrictPrice;
      }
    },
    showUtility: function () {
      this.isShowUtility = this.isShowUtility ? false : true;
      if (this.isShowUtility) {
        this.dataUtilityStartDate = this.getUtilityDate();
        this.dataUtilityEndDate = this.getUtilityDate(true);
      } else {
        this.dataUtilityStartDate = this.dataUtilityEndDate = "";
      }
    },

    onDataInvoiceExpiredDate: function () {
      this.dataInvoiceExpiredDate = this.$moment(this.dataInvoiceDate)
        .add(10, "days")
        .format("YYYY-MM-DD");
      // this.dataUtilityStartDate = this.$moment().clone().format('YYYY-MM-DD'),
      // this.dataUtilityEndDate = '',
    },

    submitNext: function () {
      if(this.dataVoidDate && this.dataVoidRef && this.dataVoidBy && this.dataVoidReason){
        this.$swal
        .fire({
          title: i18n.t("general.success.title"),
          text: 'សូមបញ្ចូលព័ត៌ខាងក្រោមដើម្បីបង្កើតវិក្ក័យបត្រថ្មី',
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t("general.ok"),
          cancelButtonText: i18n.t("general.cancel"),
        })
        .then((result) => {
          if (result.value) {
            this.isVoid = true;
          }
        });
      }else{
        this.$swal.fire({
          title: 'ព័ត៌មានមិនត្រឹមត្រូវ',
          text: 'សូមបញ្ចូលព័ត៌មានអោយបានគ្រប់គ្រាន់',
          icon: "warning",
          confirmButtonText: i18n.t('general.ok')
        });
      }
    },

    submitSave: function () {
      if(this.dataVoidDate && this.dataVoidRef && this.dataVoidBy && this.dataVoidReason){
        this.$swal
        .fire({
          title: i18n.t("general.success.title"),
          text: 'សូមបញ្ចូលព័ត៌ខាងក្រោមដើម្បីបង្កើតវិក្ក័យបត្រថ្មី',
          icon: "success",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t("general.ok"),
          cancelButtonText: i18n.t("general.cancel"),
        })
        .then((result) => {
          if (result.value) {
            this.isVoid = true;
          }
        });
      }

      this.tryingToSubmit = true;
      let list = [];
      Object.keys(this.$refs).map((el) => {
        // console.log(this.$refs[el]);
        if ("getItem" in this.$refs[el][0]) {
          let partner = this.$refs[el][0].getItem();
          if (partner != null && partner.check) {
            list.push(partner);
          }
        }
      });

      // validate
      if (
        (this.dataElectrict < this.dataLastElectrict ||
          this.dataWatter < this.dataLastWatter) &&
        this.isShowUtility
      ) {
        this.tryingToSubmit = false;
        return false;
      } else {
        if (!(this.dataElectrict || list.length)) {
          this.tryingToSubmit = false;
          return false;
        }
      }

      let data_watter = {
        id: "w1",
        quantity: this.dataWatter - this.dataLastWatter,
        price: this.dataWatterPrice,
        amount: this.dataWatterAmount,
        check: false,
        name: "ទឹក",
        name_en: "Watter",
        monthBilling: 0,
        old_record: this.dataLastWatter,
        new_record: this.dataWatter,
        old: this.dataLastWatter,
        current: this.dataWatter,
        service_for:
          this.propertyData.is_rent == 1 && this.propertyData.tenant_id != ""
            ? 2
            : 1,
      };
      let data_electrict = {
        id: "e1",
        quantity: this.dataElectrict - this.dataLastElectrict,
        price: this.dataElectrictPrice,
        amount: this.dataElectrictAmount,
        check: false,
        name: "ភ្លើង",
        name_en: "Electrict",
        monthBilling: 0,
        old_record: this.dataLastElectrict,
        new_record: this.dataElectrict,
        old: this.dataLastElectrict,
        current: this.dataElectrict,
        service_for:
          this.propertyData.is_rent == 1 && this.propertyData.tenant_id != ""
            ? 2
            : 1,
      };
      if (this.isShowUtility) {
        list.push(data_watter);
        list.push(data_electrict);
      }

      let dataSubmit = {
        invoice_type: 1,
        project_id: this.dataProjectId,
        property_id: this.dataPropertyId,
        invoice_date: this.dataInvoiceDate,
        expired_date: this.dataInvoiceExpiredDate,
        start_date: this.dataUtilityStartDate,
        end_date: this.dataUtilityEndDate,
        watter: this.isShowUtility ? data_watter : "",
        electrict: this.isShowUtility ? data_electrict : "",
        void_date: this.dataVoidDate, 
        void_reason: this.dataVoidReason, 
        void_ref: this.dataVoidRef, 
        inv_id: this.invoiceData.invoice.id, 
        void_by: this.dataVoidBy, 
        
        services: list,
      };

      console.log(dataSubmit);
      invoiceService.voidInvoice(dataSubmit).then((response) => {
        this.tryingToSubmit = false;
        console.log(response);
        if (response.status == 200) {
          this.$swal
            .fire({
              title: i18n.t("general.success.title"),
              text: i18n.t("general.success.message"),
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t("general.ok"),
              cancelButtonText: i18n.t("general.success.no"),
            })
            .then((result) => {
              if (result.value) {
                this.$router.push(
                  this.$route.query.redirectFrom || {
                    name: "manage-property-invoice",
                    params: { id: response.data.id },
                  }
                );
              }
            });
        }
      });
    },
    submitCancel: function () {
      this.$swal
        .fire({
          title: i18n.t("general.cancel-confirm.title"),
          text: i18n.t("general.cancel-confirm.message"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#f46a6a",
          confirmButtonText: i18n.t("general.cancel-confirm.yes"),
          cancelButtonText: i18n.t("general.cancel"),
        })
        .then((result) => {
          if (result.value) {
            this.$router.push(
              this.$route.query.redirectFrom || {
                name: "manage-property",
              }
            );
          }
        });
    },
    clearForm: function () {
      this.dataProperty = 0;
    },
  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader
        :items="[
          {
            text: $t('invoice.void'),
            href: '/manage/invoice',
          },
          {
            text: $t('invoice.text'),
            active: true,
          },
        ]"
        :title="$t('invoice.text') + $t('invoice.void')"
      />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!-- void info  -->
            <section>
              <div class="row">
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-sm-4">
                      <Input
                        :type="'date'"
                        :id="'void_date'"
                        v-model="dataVoidDate"
                        :require="true"
                        :label="'invoice.void-date'"
                      />
                    </div>
                    <div class="col-sm-4">
                      <Input
                        :type="'text'"
                        :id="'void_reference'"
                        v-model="dataVoidRef"
                        :require="true"
                        :label="'invoice.void-reference'"
                      />
                    </div>
                    <div class="col-sm-4">
                      <Input
                        :type="'text'"
                        :id="'void_by'"
                        v-model="dataVoidByName"
                        :require="true"
                        :label="'invoice.void-by'"
                      />
                    </div>
                    
                  </div>
                  <div class="row">
                    <div class="col">
                      <Area 
                        :rows="7"
                        :id="'void_reason'"
                        v-model="dataVoidReason"
                        :require="true"
                        :label="'invoice.void-reason'"  />
                    </div>
                  </div>
                  <div class="row" v-if="!isVoid">
                    <div class="col-2">
                      <Button
                        v-bind:icon="'fa fa-arrow-right'"
                        v-bind:buttonType="'button'"
                        @click="submitNext()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="'បន្ទាប់'"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-sm-4 shadow-sm">
                  <p>{{$t('invoice.void-info')}}</p>
                  <p>{{$t('commission.code')}}: {{this.invoiceData.invoice.code}}</p>
                  <p>{{$t('invoice.date')}}: {{this.invoiceData.invoice.invoice_date}}</p>
                  <p>{{$t('invoice.amount')}}: ${{this.invoiceData.invoice.total}}</p>
                </div>
              </div>
            </section>
            <!-- new invoice  -->
            <section class="border-top mt-1" v-if="isVoid">
              <div class="row mt-3">
                <div class="col">
                  <h5>{{$t('invoice.new')}}</h5>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-3">
                  <Input
                    @input="onDataInvoiceExpiredDate()"
                    :type="'date'"
                    :id="'invoice_date'"
                    v-model="dataInvoiceDate"
                    :require="true"
                    :label="'invoice.date'"
                  />
                </div>
                <div class="col-sm-3">
                  <Input
                    :type="'date'"
                    :id="'expired_date'"
                    v-model="dataInvoiceExpiredDate"
                    :require="true"
                    :label="'booking.expired'"
                  />
                </div>
                <div class="col-sm-3">
                  <Input
                    :type="isShowUtility ? 'date' : 'text'"
                    :id="'start_date'"
                    v-model="dataUtilityStartDate"
                    :require="isShowUtility ? true : false"
                    :disabled="!isShowUtility ? true : false"
                    :label="'manage.utility.start-date'"
                  />
                </div>
                <div class="col-sm-3">
                  <Input
                    :type="isShowUtility ? 'date' : 'text'"
                    :id="'end_date'"
                    v-model="dataUtilityEndDate"
                    :require="isShowUtility ? true : false"
                    :disabled="!isShowUtility ? true : false"
                    :label="'manage.utility.end-date'"
                  />
                </div>
              </div>
              <div class="row pt-3 border-bottom mb-3">
                <div class="col-1">
                  <label class="khb text-left" for="flexSwitchCheckDefault">{{
                    $t("manage.utility.text")
                  }}</label>
                </div>
                <!-- <div class="col">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" @change="showUtility()"> 
                </div>
              </div> -->
              </div>
              <div v-if="isShowUtility">
                <div class="row">
                  <div class="col-md-3">
                    <Input
                      :type="'number'"
                      :id="'last_watter'"
                      v-model="dataLastWatter"
                      :require="true"
                      :editable="false"
                      :label="'manage.last-month-watter-record'"
                    />
                  </div>
                  <div class="col-md-3">
                    <Input
                      @input="watterChanged()"
                      :type="'number'"
                      :id="'current_watter'"
                      v-model="dataWatter"
                      :require="true"
                      :label="'manage.current-month-watter-record'"
                    />
                  </div>
                  <div class="col-md-3">
                    <label>{{ $t("invoice.price") }} / M <sup>3</sup></label>
                    <Input
                      @input="watterChanged()"
                      :type="'number'"
                      :id="'watter_price'"
                      v-model="dataWatterPrice"
                      :require="true"
                    />
                  </div>
                  <div class="col-md-3">
                    <Input
                      :type="'number'"
                      :id="'watter_amount'"
                      v-model="dataWatterAmount"
                      :disabled="true"
                      :label="'expense.amount'"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-3">
                    <Input
                      :type="'number'"
                      :id="'last_electrict'"
                      v-model="dataLastElectrict"
                      :require="true"
                      :editable="false"
                      :label="'manage.last-month-electrict-record'"
                    />
                  </div>
                  <div class="col-sm-3">
                    <Input
                      @input="electrictChanged()"
                      :type="'number'"
                      :id="'current_electrict'"
                      v-model="dataElectrict"
                      :require="true"
                      :label="'manage.current-month-electrict-record'"
                    />
                  </div>
                  <div class="col-sm-3">
                    <label>{{ $t("invoice.price") }} / KWH</label>
                    <Input
                      @input="electrictChanged()"
                      :type="'number'"
                      :id="'electrict_price'"
                      v-model="dataElectrictPrice"
                      :require="true"
                    />
                  </div>
                  <div class="col-sm-3">
                    <Input
                      :type="'number'"
                      :id="'electrict_amount'"
                      :disabled="true"
                      v-model="dataElectrictAmount"
                      :label="'expense.amount'"
                    />
                  </div>
                </div>
              </div>

              <div class="row pt-3 d-none">
                <div class="col">
                  <p class="khb border-bottom">
                    {{ $t("manage.service.text") }}
                  </p>
                </div>
              </div>

              <div class="row d-none">
                <div class="col-sm">
                  <div class="row border-top pt-3 bg-light">
                    <div class="col-sm-1">
                      <p class="">ជ្រើសរើស</p>
                    </div>
                    <div class="col-sm">
                      <p class="">សម្រាប់</p>
                    </div>
                    <div class="col-sm-3">
                      <p class="">
                        {{ $t("manage.service.name")
                        }}{{ $t("manage.service.text") }}
                      </p>
                    </div>
                    <div class="col-sm-2">
                      <p class="">
                        {{ $t("manage.billing_cycle_date") }}({{
                          $t("manage.yearly")
                        }})
                      </p>
                    </div>
                    <div class="col-sm">
                      <p class="">{{ $t("invoice.quantity") }}</p>
                    </div>
                    <div class="col-sm">
                      <p class="">{{ $t("invoice.price") }}</p>
                    </div>
                    <div class="col-sm">
                      <p class="">{{ $t("invoice.total") }}</p>
                    </div>
                  </div>

                  <ServiceRow
                    v-for="(item, index) in modifiedServiceData"
                    :key="index"
                    :ref="'service_' + index"
                    :item="item"
                    :index="index + 1"
                    :lookServiceFor="true"
                  />
                </div>
              </div>

              <br />
              <div class="row">
                <div class="col-lg-12">
                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button
                        v-bind:icon="'bx bx-x-circle'"
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"
                      />
                    </div>
                    <div class="col-sm-auto">
                      <Button
                        v-bind:icon="'bx bx-save bx-tada'"
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </b-form>
  </Layout>
</template>